(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-ingredients"] && !Shopify.designMode) return;
  try {
    
  $('.toggle-button-box span.button').click (function(){
        $('.toggle-button-box .button-description').toggleClass('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wf-product-details"] && !Shopify.designMode) return;
  try {
    
function wfSetDisplayTitle() {
  const content = document.querySelector('.wf-four-preview [data-wf-title]');
  const heading = document.querySelector('.wf-four-preview .product-single__title');
  if (content && heading) heading.textContent = content.dataset.wfTitle;
}
wfSetDisplayTitle();
document.addEventListener('DOMContentLoaded', wfSetDisplayTitle, { once: true });
document.addEventListener('shopify:section:load', wfSetDisplayTitle);

  } catch(e) { console.error(e); }
})();
})();
